module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Absurd","short_name":"absurd","start_url":"/","background_color":"#8bd8ed","theme_color":"#8bd8ed","display":"minimal-ui","icon":"static/favicon.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"6476756a17d3f883f554d7d447f79104"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
